import axios from 'axios';

export interface ClassifiedError {
  message: string;
  severity: 'error' | 'warning';
}

export function classifySubmitError(error: unknown): ClassifiedError {
  // PLATFORM-3336: timeout do cliente (AbortSignal), não resposta do servidor —
  // sem `response`, então cairia no branch genérico de rede abaixo sem este caso.
  // Reconciliação já foi tentada (ver useSubmitPunchcard); chegar aqui com esse
  // erro significa que não achou coleta correspondente — reenviar é seguro.
  if (axios.isCancel(error)) {
    return { message: 'Tempo esgotado, tente novamente.', severity: 'warning' };
  }
  const status = (error as { response?: { status?: number } })?.response?.status;
  const data = (error as { response?: { data?: { message?: string } } })?.response?.data;
  if (status === 403) {
    return {
      message:
        'Operação não permitida: você não tem permissão para registrar este ponto. Essa ação foi registrada para auditoria.',
      severity: 'warning',
    };
  }
  if (status !== undefined && status >= 400 && status < 500) {
    return {
      message: `Erro do usuário: ${data?.message ?? 'Verifique seus dados e tente novamente.'}`,
      severity: 'error',
    };
  }
  if (status !== undefined && status >= 500) {
    return { message: 'Erro do servidor: tente novamente mais tarde.', severity: 'error' };
  }
  return { message: 'Erro de rede ou inesperado ao registrar ponto.', severity: 'error' };
}
